<template>
  <v-layout justify-center align-center column :class="readonly ? '' : 'mb-2'">
    <v-layout mb-3>
      <v-layout class="round-background" align-center justify-center>
        <v-img
          :max-width="image ? '15em' : '10em'"
          :max-height="image ? '15em' : '10em'"
          :src="imageSrc"
          :class="image ? 'round-background' : ''"
          :lazy-src="`${require('@/assets/images/placeholders/bear.svg')}`"
          aspect-ratio="1"
        />
      </v-layout>
    </v-layout>
    <v-layout v-if="!readonly" align-center justify-center>
      <input id="input-image" ref="input" type="file" hidden @change="onChange" accept="image/*"/>
      <v-btn color="primary" @click="dispatchInput">{{ hasImage ? 'Alterar imagem/Change image' : 'Adicionar imagem/Add image' }}</v-btn>
    </v-layout>
  </v-layout>
</template>

<script>
/**
 * @group Input
 * Componente responsável pela seleção de imagens transformação em Base64
 */
export default {
  name: 'InputImage',

  props: {
    image: {
      type: String,
      default: ''
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    hasImage () {
      return !!this.image
    },

    imageSrc () {
      return this.image || require('@/assets/images/placeholders/bear.svg')
    }
  },

  methods: {
    dispatchInput () {
      this.$refs.input.click()
    },

    /**
     * @vuese
     * Método responsável pelo evento de imagem
     */
    onChange (imageEvent) {
      this.inputPreview(imageEvent.target.files[0])
    },

    /**
     * @vuese
     * Método responsável pelo tratamento de imagem e transformação em Base64
     */
    inputPreview (file) {
      let reader = new FileReader()

      reader.onloadend = () => {
        this.$emit('image', reader.result)
      }

      if (file && this.validFileType(file)) {
        this.errorFile = false
        reader.readAsDataURL(file)
      } else if (!this.validFileType(file)) {
        this.$emit('error', 'Arquivo inválido!')
      } else {
        this.$emit('error', 'Erro ao carregar arquivo!')
      }
    },

    /**
     * @vuese
     * Método responsável pela validação do arquivo
     */
    validFileType (file) {
      var _validFileExtensions = ['.jpg', '.jpeg', '.bmp', '.gif', '.png']

      var fileName = file.name
      if (fileName.length > 0) {
        for (var i = 0; i < _validFileExtensions.length; i++) {
          var validExtension = _validFileExtensions[i]
          if (fileName.substr(fileName.length - validExtension.length, validExtension.length).toLowerCase() === validExtension.toLowerCase()) {
            return true
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="stylus" scoped>
.round-background
  border-radius 50%
  width 15em
  height 15em
  background-color #888
  image-orientation from-image
</style>
